import React from 'react'

import { ButtonClean, Icon } from '@fourthwall/components'
import { NewWindowIcon } from '@fourthwall/icons'

import GoogleAnalyticsIcon from '../../assets/google-analytics-icon.svg'
import * as S from './styled'

type GoogleAnalyticsReportBottomContentProps = {
  href?: string
}

export const GoogleAnalyticsReportBottomContent = ({
  href,
}: GoogleAnalyticsReportBottomContentProps) => {
  return (
    <S.Container>
      <S.Icon>
        <img src={GoogleAnalyticsIcon} alt="Google Analytics Logo" />
      </S.Icon>
      This data comes from Google Analytics and is gathered from the moment you added the
      integration.{` `}
      {href && (
        <ButtonClean
          appearance="secondary"
          label={
            <S.Label>
              View in Google Analytics
              <Icon component={NewWindowIcon} height={10} />
            </S.Label>
          }
          href={href}
          target="_blank"
        />
      )}
    </S.Container>
  )
}
